import { FROM_WEB_VIEW } from 'voxguru-v1/utils/constants';

const getIsWebView = () => localStorage.getItem(FROM_WEB_VIEW) === 'true';

export default getIsWebView;
